<app-spinner-overlay></app-spinner-overlay>
<h2 mat-dialog-title>Destinatario di Applicazione della Policy di Sostenibilità</h2>
<div mat-dialog-content class="dialog-center-cont">
  <form [formGroup]="formPerimetroPolicy" appFormContainer [larghezza]="2">
    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Destinatario</mat-label>
      <input matInput placeholder="Destinatario" formControlName="descrizione" />
      <mat-error appFormError></mat-error>
    </mat-form-field>

    <div appFormElement [larghezza]="4" [riempi]="true" class="testo-linea-guida">
      <div style="display: flex">
        <mat-icon class="material-icons-outlined icone-tem">error</mat-icon>
      </div>
      <div class="titolo-linea-guida">
        Definisci e descrivi le modalità di attuazione della Policy di Sostenibilità per il
        destinatario selezionato.
      </div>
    </div>

    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Descrizione attuazione</mat-label>
      <textarea
        matInput
        placeholder="Descrizione attuazione"
        formControlName="lineaGuidaPolicy"
        [rows]="5"
      ></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
